var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { findPlayerById } from "../players/utils";
import { MatchStatsForm, } from "./MatchStatsForm";
import { findPlayerIntraSquadMatchStatByPlayerId } from "./utils";
export var IntraSquadMatchStatsForm = function (_a) {
    var _b, _c;
    var intraSquadMatch = _a.intraSquadMatch, onSubmit = _a.onSubmit, players = _a.players, teamPreferences = _a.teamPreferences;
    var getPlayerIntraSquadMatchStat = findPlayerIntraSquadMatchStatByPlayerId((intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.playerIntraSquadMatchStats) || []);
    var getPlayer = findPlayerById(players || []);
    // Resolve player IDs to player objects
    var teamAPlayers = intraSquadMatch.teamAPlayers
        .map(getPlayer)
        .filter(function (p) { return p !== undefined; });
    var teamBPlayers = intraSquadMatch.teamBPlayers
        .map(getPlayer)
        .filter(function (p) { return p !== undefined; });
    var initialPlayerStats = __spreadArray(__spreadArray([], __read(intraSquadMatch.teamAPlayers), false), __read(intraSquadMatch.teamBPlayers), false).map(function (playerId) {
        var playerIntraSquadMatchStat = getPlayerIntraSquadMatchStat(playerId);
        return {
            teamId: intraSquadMatch.team,
            playerId: playerId,
            goalsScored: playerIntraSquadMatchStat === null || playerIntraSquadMatchStat === void 0 ? void 0 : playerIntraSquadMatchStat.goalsScored,
            yellowCards: playerIntraSquadMatchStat === null || playerIntraSquadMatchStat === void 0 ? void 0 : playerIntraSquadMatchStat.yellowCards,
            redCards: playerIntraSquadMatchStat === null || playerIntraSquadMatchStat === void 0 ? void 0 : playerIntraSquadMatchStat.redCards,
            id: playerIntraSquadMatchStat === null || playerIntraSquadMatchStat === void 0 ? void 0 : playerIntraSquadMatchStat.id,
        };
    });
    var handleSubmit = function (result, playerStats) {
        var _a;
        var intraSquadMatchResult = {
            id: (_a = intraSquadMatch.intraSquadMatchResult) === null || _a === void 0 ? void 0 : _a.id,
            intraSquadMatchId: intraSquadMatch.id,
            teamAScore: result.leftTeamScore,
            teamBScore: result.rightTeamScore,
        };
        var playerIntraSquadMatchStats = playerStats.map(function (stat) { return ({
            id: stat.id,
            playerId: stat.playerId,
            teamId: stat.teamId,
            goalsScored: stat.goalsScored,
            yellowCards: stat.yellowCards,
            redCards: stat.redCards,
            intraSquadMatchId: intraSquadMatch.id,
        }); });
        onSubmit(intraSquadMatchResult, playerIntraSquadMatchStats);
    };
    return (_jsx(MatchStatsForm, { leftTeamName: teamPreferences.teamAName || "Team A", rightTeamName: teamPreferences.teamBName || "Team B", leftTeamPlayers: teamAPlayers, rightTeamPlayers: teamBPlayers, initialLeftScore: (_b = intraSquadMatch.intraSquadMatchResult) === null || _b === void 0 ? void 0 : _b.teamAScore, initialRightScore: (_c = intraSquadMatch.intraSquadMatchResult) === null || _c === void 0 ? void 0 : _c.teamBScore, initialPlayerStats: initialPlayerStats, onSubmit: handleSubmit }));
};
